import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import {
  GetExperienceResponseBodyType,
  MetricArrayType,
} from "@intelligems/ig-types";
import { UseQueryResult } from "@tanstack/react-query";

import { setDashboardFilterByPersonalization } from "../../store/slices/dashboardFilters";
import { useConfiguration } from "../configurations/use-configuration";
import { useGetExperience } from "../experiences/get-experience";

export const personalizationKeys = {
  all: (includeDiscount: boolean) =>
    [{ scope: "personalizations", includeDiscount }] as const,
  selected: (personalizationId: string) =>
    [{ ...personalizationKeys.all[0], campaignId: personalizationId }] as const,
  one: (personalizationId: string) =>
    [{ scope: "personalization", campaignId: personalizationId }] as const,
};

export const useDashboardPersonalizationOrDefault = (
  dashboardData?: MetricArrayType,
  experienceId?: string
): UseQueryResult<GetExperienceResponseBodyType, Error> => {
  const maxZScore = useConfiguration<string>("max_z_score");
  const dispatch = useDispatch();
  const { id: paramId } = useParams<{ id?: string }>();

  const id = experienceId || paramId;

  const query = useGetExperience(id || undefined);

  useEffect(() => {
    if (query.isSuccess) {
      dispatch(
        setDashboardFilterByPersonalization({
          experienceId: query.data.experience.id,
          dashboardData,
          maxZScore: maxZScore!.value,
        })
      );
    }
  }, [query.isSuccess]);

  return query;
};
